
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import hiddenVisuallyDemo from './demo/hidden-visually.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Utilities/Display" mdxType="Meta" />
    <h1>{`Display`}</h1>
    <p>{`Utilities for specifying the display type of an element.`}</p>
    <p>{`Contrary to other categories of utilities, there is no shared `}<inlineCode parentName="p">{`display-*`}</inlineCode>{` class name prefix. This is for two main reasons:`}</p>
    <ul>
      <li parentName="ul">{`It would be confusing for display utilities that do not conform to a known display type (for example, `}<inlineCode parentName="li">{`u-hidden-visually`}</inlineCode>{`) to include this segment.`}</li>
      <li parentName="ul">{`Display utilities are more likely to serve as a base for other dependent utility classes. It is more intuitive to have a (currently hypothetical) `}<inlineCode parentName="li">{`u-flex`}</inlineCode>{` class and `}<inlineCode parentName="li">{`u-flex-align-items-center`}</inlineCode>{` than it would be `}<inlineCode parentName="li">{`u-display-flex`}</inlineCode>{` and `}<inlineCode parentName="li">{`u-flex-align-items-center`}</inlineCode>{`.`}</li>
    </ul>
    <h2>{`Hidden Visually`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`u-hidden-visually`}</inlineCode>{` class applies a complex set of CSS rules that obscure an element visually but `}<a parentName="p" {...{
        "href": "https://cloudfour.com/thinks/see-no-evil-hidden-content-and-accessibility/#showing-additional-content-for-screen-readers"
      }}>{`not from assistive technology like screen readers`}</a>{`.`}</p>
    <p>{`In this example, the link will include text when read aloud:`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Hidden Visually" mdxType="Story">{hiddenVisuallyDemo}</Story>
    </Canvas>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const hiddenVisually = assertIsFn(hiddenVisuallyDemo);
hiddenVisually.storyName = 'Hidden Visually';
hiddenVisually.parameters = { storySource: { source: 'hiddenVisuallyDemo' } };

const componentMeta = { title: 'Utilities/Display', includeStories: ["hiddenVisually"],  };

const mdxStoryNameToKey = {"Hidden Visually":"hiddenVisually"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;